import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.ChartCircTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Chart, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.ChartCircTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.ChartCircTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.ChartCircTypeConst.CLASS) ?? '']: true }),
        name: _ctx.getPropertyValue(_ctx.ChartCircTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.ChartCircTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.ChartCircTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.ChartCircTypeConst.PLACEHOLDER),
        type: _ctx.getCatalogValue(_ctx.ChartCircTypeConst.TYPE),
        plugins: _ctx.getPropertyValue(_ctx.ChartCircTypeConst.PLUGINS),
        width: _ctx.getPropertyNumberValue(_ctx.ChartCircTypeConst.WIDTH),
        height: _ctx.getPropertyNumberValue(_ctx.ChartCircTypeConst.HEIGHT),
        data: _ctx.chartData,
        options: _ctx.chartOptions,
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, {
        default: _withCtx(() => [
          _createCommentVNode(" :usePointStyle=\"getPropertyBooleanValue(ChartCircTypeConst.USEPOINTSTYLE)\"\r\n        :color=\"getPropertyValue(ChartCircTypeConst.COLOR)\"\r\n        :backgroundColor=\"getPropertyValue(ChartCircTypeConst.BACKGROUNDCOLOR)\"\r\n        :hoverBackgroundColor=\"getPropertyValue(ChartCircTypeConst.HOVERBACKGROUNDCOLOR)\"\r\n        :cutout=\"getPropertyValue(ChartCircTypeConst.CUTOUT)\" \r\n        :labelData=\"getCatalogValue(ChartTypeConst.LABELDATA)\"\r\n        ")
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "type", "plugins", "width", "height", "data", "options", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.ChartCircTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}